import { PerPatientQuestionStats, PermissionBit } from "../../../api";
import { DataModel } from "../../../models/data-model";

export class QuestionnaireStatsModel extends DataModel<PerPatientQuestionStats> {
  constructor(
    data: PerPatientQuestionStats[],
    permissions?: PermissionBit[],
    userUUID?: string,
  ) {
    super(data, permissions, userUUID);
  }
}
